module.exports = __webpack_public_path__ + "static/media/6.6083eaf6.png";